import { Component, Input, SimpleChanges } from "@angular/core";

@Component({
    selector: "web-user-approval-shimmer",
    templateUrl: "./user-approval-shimmer.component.html",
    styleUrls: ["./user-approval-shimmer.component.scss"],
})
export class UserApprovalShimmerComponent {
    skeletonCount: number | undefined = 7;
    skeletonWidthsLeft = [50, 60, 40, 20, 50, 40, 70];
    skeletonWidthsRight = [60, 40, 50, 40, 60, 60, 30];

    @Input() rowCount: number | undefined;
    @Input() height = "10px";
    @Input() width = "100%";

    ngOnChanges(changes: SimpleChanges): void {
        if (changes["rowCount"]) {
            this.skeletonCount = this.rowCount || 1;
        }
    }

    counter(count: number = 1): number[] {
        return Array.from({ length: count });
    }
}
